import { Reveal } from "@/components/Motion";
import { WHO_SHOULD_ATTEND, EXPERIENCE_REQS } from "@/data/content";
import { Check } from "lucide-react";

const Audience = () => {
  return (
    <section
      id="audience"
      data-testid="audience"
      className="relative py-28 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-16">
        {/* Who should attend */}
        <div data-testid="who-should-attend" className="flex flex-col">
          <Reveal>
            <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#16fcfb]">
              [ 004 ] Who Should Attend
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display font-700 text-3xl md:text-4xl leading-tight tracking-tight text-white">
              HCASP is tailored for professionals looking to build or demonstrate practical AI security skills:
            </h2>
          </Reveal>

          <ul className="mt-10 flex-1 flex flex-col justify-between space-y-4">
            {WHO_SHOULD_ATTEND.map((item, i) => (
              <Reveal key={item.role} delay={0.05 * i}>
                <li className="flex items-start gap-4 border-b border-[#3d414f] pb-4">
                  <span className="font-mono2 text-xs text-[#16fcfb] mt-1.5">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-body text-base md:text-lg text-white/85">
                    <span className="text-white font-600">{item.role}</span>{" "}
                    <span className="text-white/60">{item.desc}</span>
                  </span>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>

        {/* Experience requirements */}
        <div data-testid="experience-requirements" className="flex flex-col">
          <Reveal>
            <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#16fcfb]">
              [ 005 ] Experience & Prerequisites 
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display font-700 text-3xl md:text-4xl leading-tight tracking-tight text-white">
              What you should bring.
            </h2>
          </Reveal>
          <Reveal delay={0.08}>
            <p className="mt-5 font-body text-base text-white/65 leading-relaxed">
              HCASP is designed to be accessible to candidates across the IT and security spectrum:
            </p>
          </Reveal>

          <div className="mt-10 flex-1 grid gap-4 auto-rows-fr">
            {EXPERIENCE_REQS.map((r, i) => (
              <Reveal key={r.title} delay={0.05 * i}>
                <div className="group h-full rounded-xl border border-[#3d414f] bg-[#404452]/20 p-6 transition-colors duration-300 hover:border-[#16fcfb]">
                  <div className="flex items-center gap-3">
                    <span className="grid h-7 w-7 place-items-center rounded-full bg-[#16fcfb]/15 text-[#16fcfb]">
                      <Check size={15} />
                    </span>
                    <h3 className="font-display font-600 text-base text-white">
                      {r.title}
                    </h3>
                  </div>
                  <p className="mt-3 font-body text-sm text-white/60 leading-relaxed">
                    {r.body}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Audience;